"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var ChatMessageAuthor_1 = __importDefault(require("./ChatMessageAuthor"));
function ChatMessage(_a) {
    var message = _a.message, showAuthor = _a.showAuthor;
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showAuthor && (0, jsx_runtime_1.jsx)(ChatMessageAuthor_1.default, { author: message.userId }), (0, jsx_runtime_1.jsx)("p", __assign({ css: textCss }, { children: message.text }))] });
}
exports.default = ChatMessage;
var textCss = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.5;\n  margin: 0;\n"], ["\n  line-height: 1.5;\n  margin: 0;\n"])));
var templateObject_1;
